<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      auto-complete="on"
      label-position="left"
    >
      <div class="title-container">
        <h3 class="title ub ub-ac ub-pc">
          <!-- <div class="icon"></div> -->

          <div class="name col-w">
            {{ showKey(systemConfig.BisWebSiteName) }}
          </div>
        </h3>
      </div>

      <div class="model-container">
        <img src="./img/style.png" alt />
        <img src="./img/string.png" alt />
        <div class="form-box">
          <div class="little-title">用户登录</div>


          <el-form-item prop="username">
            <span class="svg-container">
              <svg-icon icon-class="user" />
            </span>

            <el-input
              v-model="loginForm.username"
              :placeholder="'账号'"
              name="username"
              type="text"
              auto-complete="on"
            />
          </el-form-item>

          <el-form-item prop="password">
            <span class="svg-container">
              <svg-icon icon-class="password" />
            </span>

            <el-input
              :type="passwordType"
              v-model="loginForm.password"
              :placeholder="'密码'"
              name="password"
              auto-complete="on"
            />
          </el-form-item>

          <!-- 验证码登录暂时屏蔽 -->
          <!-- <div class="ub">
            <el-form-item prop="verification" class="ub-f1">
              <el-input
                v-model="loginForm.verification"
                :placeholder="'验证码'"
                name="verification"
                auto-complete="on"
              />
            </el-form-item>
            <div class="verification-box">
              <img :src="verImg" @click="refreshCode">
            </div>
          </div>-->

          <div class="button">
            <el-button
              :loading="loading"
              type="primary"
              style="width:100%;margin-bottom:30px;"
              @click.native.prevent="handleLogin('loginForm')"
            >
              登录
            </el-button>
          </div>

          <!-- <div class="addition">
            <span>忘记密码</span>
            <span class="line"></span>
            <span>查看帮助</span>
            <span class="line"></span>
            <span>重置</span>
          </div>-->

          <!-- <el-button
            :loading="loading"
            type="primary"
            style="width:100%;margin-bottom:30px;"
            @click.native.prevent="handleLogin('loginForm')"
          >
            登录
          </el-button>-->
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
//import { isvalidUsername } from '@/utils/validate';
import { mapMutations } from 'vuex';
import {
  setToken,
  setDivision,
  getDivision,
  setSystem,
  getSystem,
} from '@/utils/auth.js';
import { CantonMgeSvr } from '@/service/CantonMgeSvr';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import { encrypt } from '@/utils/encryption.js';
import { mapState } from 'vuex';
import router from '@/router/router';
// import { identityEnum } from '@/enum/identityEnum';
// import { VerificationCodeController } from '@/service/VerificationCodeController/VerificationCodeController.js';
import { showKey, handleTitle } from '@/utils/dev-helper.js'

export default {
  components: {},
  props: {},
  data() {
    /** 验证用户名 */
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };

    /** 验证密码 */
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
        if (value.length < 6) {
          callback(new Error('密码不得小于6位'));
        } else {
          callback();
        }
      }
    };

    /** 验证验证码 */
    // const validateVerification = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('验证码不能为空'));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      /** 请求器 */
      AuthenticationControllerSvr: new AuthenticationControllerSvr(),
      SysConfigServiceSvr: new SysConfigServiceSvr(),
      // verificationCodeController: new VerificationCodeController(),

      /** 登录表单 */
      loginForm: {
        username: '',
        password: '',
        verification: '',
      },

      /** 验证码图片 */
      verImg:
        'data:image/jpeg;base64,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',

      /** 登录表单验证 */
      loginRules: {
        /** 用户名验证规则 */
        username: [
          { required: true, trigger: 'blur', validator: validateUsername },
        ],
        /** 密码验证规则 */
        password: [
          { required: true, trigger: 'blur', validator: validatePassword },
        ],
        /** 验证码验证规则 */
        // verification:[
        //   {required:true,trigger:'blur',validator:validateVerification }
        // ]
      },

      /** 密码显示类型 */
      passwordType: 'password',

      /** 登录按钮加载标识 */
      loading: false,

      /** 身份枚举 */
      // identityEnum: new identityEnum(),

      /** 系统配置 */
      systemConfig: '',
    };
  },
  computed: {
    /** 注入仓库数据 */
    ...mapState([
      'userInfo',
      'addRouters',
    ]),
  },
  created() {
    if (this.addRouters.length > 0) {
      location.reload();
    }
  },
  mounted() {
    // 若储存无配置数据 (BisWebSiteName)
    if (
      getSystem() === undefined ||
      getSystem() === null ||
      getSystem() === ''
    ) {
      // 获取系统配置
      this.SysConfigServiceSvr
        .getSystemConfig('BisWebSiteName')
        .then((res) => {
          // 获取配置
          this.systemConfig = res;

          // 使用配置
          setSystem(res);

          // 设置标题
          handleTitle(this.systemConfig.BisWebSiteName)
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    }
    // 若存在配置配置数据 (BisWebSiteName)
    else {
      // 获取配置
      this.systemConfig = JSON.parse(getSystem());

      // 设置标题
      handleTitle(this.systemConfig.BisWebSiteName)
    }

    // this.refreshCode();

    // 监听回车事件
    document.onkeydown = (e) => {
      if (e.keyCode === 13) {
        this.handleLogin('loginForm');
      }
    };
  },
  beforeDestroy() {
    // 销毁回车事件监听
    document.onkeydown = null;
  },
  methods: {
    /** 注入仓库辅助函数 */
    ...mapMutations([
      'SET_USERINFO',
      'SET_USERROLEINFO',
      'SET_TOKEN',
      'SET_SYSTEM',
      'SET_SHOWBTN',
    ]),

    /** 显示关键词 */
    showKey(str) {
      return showKey(str)
    },
    
    /** 刷新验证码 */
    // refreshCode() {
    //   this.verificationCodeController
    //     .GetVerificationCodePicStr(this.token)
    //     .then((res) => {
    //       this.verImg = res;
    //     })
    //     .catch((err) => {
    //       this.$message({
    //         type: 'error',
    //         message: err.Msg,
    //       });
    //     });
    // },

    /** 处理登录 */
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          // 验证码登录 暂时屏蔽
          // this.verificationCodeController.CheckVerificationCode(this.loginForm.verification).then(res=>{
          //   if(res==='true'){
          //     this.AuthenticationControllerSvr.loginWithCode(
          //       this.loginForm.username,
          //       encrypt(this.loginForm.password),
          //       this.loginForm.verification
          //     )
          //       .then(res => {
          //         if (res.Token && res.NickName) {
          //           this.loading = false;
          //           setToken(res.Token);
          //           this.SET_TOKEN(res.Token);
          //           router.push('/index');
          //         } else {
          //           this.loading = false;
          //           this.$message({ type: 'error', message: '登录错误' });
          //         }
          //       })
          //       .catch(err => {
          //         this.$message({ type: 'error', message: err.Msg });
          //         this.loading = false;
          //       });
          //   }else{
          //     this.$message({ type: 'error', message: '验证码错误' });
          //     this.loading = false;
          //   }
          // });
          this.AuthenticationControllerSvr.login(
            this.loginForm.username,
            encrypt(this.loginForm.password)
          )
            .then((res) => {
              // debugger;
              if (res.Token && res.NickName) {
                this.loading = false;

                this.getUserRole(res.Token);
                setToken(res.Token);
                this.SET_TOKEN(res.Token);
                this.$store.dispatch('GetUserRoleInfo').then((res) => {});
                // console.warn('this.$store', this.$store);
                if (
                  getDivision() === '' ||
                  getDivision() === undefined ||
                  getDivision() === null
                ) {
                  new CantonMgeSvr().GetCityCantonCode('').then((res) => {
                    setDivision(res);
                  });
                }
                router.push('/index');
              } else {
                this.loading = false;
                this.$message({ type: 'error', message: '登录错误' });
              }
            })
            .catch((err) => {
              this.$message({ type: 'error', message: err.Msg });
              this.loading = false;
            });
        } else {
          return false;
        }
      });
      // this.SET_USERINFO('usertype');
      // this.SET_TOKEN('14523415214421');
      // setToken('14523415214421');
      // this.$router.push('index');
    },

    /** 获取用户角色信息 */
    getUserRole(token) {
      this.AuthenticationControllerSvr.getUserRole(token)
        .then((res) => {
          // 储存身份信息
          if (res.UNIQID) { 
            sessionStorage.setItem('UNIQID', res.UNIQID);
          }

          // 储存角色信息
          if (res && res.RoleList && res.RoleList.length > 0) {
            sessionStorage.setItem('roleInfo', JSON.stringify(res.RoleList[0]));
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
  },
};
</script>


<style  lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$cursor: #fff;
$dark_gray: #889aa4;

// @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
//   .login-container .el-input input {
//     &::first-line {
//     }
//   }
// }

/* reset element-ui css */
.login-container {

  .button {
    font-size: 24px;
  }

  .el-input {
    display: inline-block;
    height: 50px;
    width: 75%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      appearance: none;
      border-radius: 0px;
      padding: 5px 5px 5px 15px;
      height: 50px;
      font-size: 18px;
      // caret-color: $cursor;
      // &:-webkit-autofill {
      //   -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
      //   -webkit-text-fill-color: $cursor !important;
      // }
    }
  }

  .el-form-item {
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 5px;
    color: #454545;
    margin-bottom: 35px;
    // margin-bottom: 25px;

    .el-form-item__content {
      line-height: 40px;
    }
  }
}

.login-container {
  height: 100%;
  min-height: 700px;
  width: 100%;
  background: linear-gradient(to right, #1965ad, #2ba3de, #1965ad);
  overflow: hidden;

  .login-form {
    position: relative;
    width: 960px;
    max-width: 100%;
    padding: 7% 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .svg-container {
    padding: 0px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      height: 80px;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;

      // .icon {
      //   width: 54px;
      //   height: 43px;
      //   background: url('./img/title-icon.png') no-repeat top center;
      //   margin-right: 16px;
      // }

      .name {
        letter-spacing: 6px;
        font-size: 30px;
        font-weight: 600;
      }
    }
  }

  .model-container {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    display: flex;
    padding: 50px 1px 1px;

    .form-box {
      flex: 1;
      padding: 0 20px;

      .little-title {
        color: #a5a5a5;
        font-size: 30px;
        margin-bottom: 35px;
        // margin-bottom: 25px;
      }

      .verification-box {
        width: 120px;
        height: 50px;
        padding: 2px 0 2px 5px;
        cursor: pointer;
        img {
          height: 100%;
          width: 100%;
        }
      }

      // .addition {
      //   display: flex;
      //   margin-bottom: 15px;
      //   cursor: pointer;

      //   span {
      //     flex: 1;
      //     color: #006ed3;
      //     font-size: 16px;
      //     text-align: center;

      //     &.line {
      //       flex: 0 0 1px;
      //       background: #006ed3;
      //     }
      //   }
      // }
    }
  }
}
</style>
